import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BulkUpdateService } from '../../../../../service/bulk-update.service';
import { MessageService } from 'primeng/api';

interface AppliedFilters {
  accountNames: string[];
  accountIds: number[];
}

@Component({
    selector: 'app-preview-media-ad-copy-bulk-update',
    templateUrl: './preview-campaign-bulk-update.component.html',
    styleUrls: ['./preview-campaign-bulk-update.component.scss'],
    standalone: false
})
export class PreviewCampaignBulkUpdateComponent {
  appliedFilters: AppliedFilters = { accountNames: [], accountIds: [] };
  // New inputs from parent: either strategy or expression will be provided
  strategy: string | null = null;
  expression: string = '';

  accounts: { id: number; name: string }[] = [];
  selectedAccountId: number | null = null;

  loading = false;
  // Keep previewData shape consistent with backend response
  previewData: {accountId: number, accountName: string, campaigns: []} = null;

  // For UI: show the outgoing request payload
  outgoingRequest: any = null;

  /**
   * Constructor for PreviewCampaignBulkUpdateComponent
   * @param ref
   * @param bulkUpdateInput
   * @param bulkUpdateService
   * @param messageService
   */
  constructor(
    public ref: DynamicDialogRef,
    public bulkUpdateInput: DynamicDialogConfig,
    private bulkUpdateService: BulkUpdateService,
    private messageService: MessageService
  ) {
    const bulkUpdateFormData = (bulkUpdateInput && bulkUpdateInput.data) || {};
    this.appliedFilters = bulkUpdateFormData.appliedFilters || { accountNames: [], accountIds: [] };
    this.strategy = bulkUpdateFormData.strategy ?? null;
    this.expression = bulkUpdateFormData.expression ?? '';

    if (this.appliedFilters?.accountIds?.length) {
      this.accounts = this.appliedFilters.accountIds.map((id: number, idx: number) => ({
        id,
        name: this.appliedFilters.accountNames[idx] || String(id)
      }));
      this.selectedAccountId = this.accounts[0]?.id ?? null;
    }
  }

  /**
   * Load the preview data using a unified preview model.
   * No branching: pass accountId plus whichever selector fields are present.
   */
  loadPreview(): void {
    if (!this.selectedAccountId) {
      this.messageService.add({ severity: 'warn', summary: 'Select Account', detail: 'Please select an account to preview.' });
      return;
    }

    const previewModel = {
      accountId: this.selectedAccountId,
      campaignType: 'Search',
      campaignStrategy: this.strategy,
      expression: this.expression || undefined,
    };

    this.outgoingRequest = previewModel;
    this.loading = true;
    this.bulkUpdateService.getBulkUpdatePreview(previewModel).subscribe({
      next: (previewData) => {
        this.previewData = previewData.preview;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        const detail = err?.error?.message || 'Failed to load bulk update preview';
        this.messageService.add({ severity: 'error', summary: 'Error', detail });
      }
    });
  }

  /**
   * Close the dialog
   */
  close(): void {
    this.ref.close();
  }

}
